var storage = {
  _prefix: '_pos_',
  set(key, value) {
    localStorage.setItem(this._prefix + key, JSON.stringify(value))
  },
  get(key) {
    var v = localStorage.getItem(this._prefix + key)
    if(v) {
      try {
        v = JSON.parse(v)
      } catch(x) {console.error(x)}
    }
    return v
  },
  remove(key) {
    localStorage.removeItem(this._prefix + key)
  },
  clear: function() {
    localStorage.clear()
  }
}

export default storage


/** WEBPACK FOOTER **
 ** ./src/app/utils/storage.js
 **/